import { useSyncExternalStore, type FC } from 'react';
import {
  ensureOppGradeStylesLoaded,
  getOppGradeStyleLabel,
  isOppGradeStylesLoaded,
  subscribeOppGradeStyles,
} from '../../utils/ipcOppGrade';

type Props = {
  grade?: string | null;
  className?: string;
};

// 模块加载时预拉一次，列表页无需各自重复请求
void ensureOppGradeStylesLoaded();

/**
 * 定级色标：颜色取自 erpa_base IPC_OPP_GRADE.style_label（error/warning/processing/default/muted）
 */
export const IpcGradeTag: FC<Props> = ({ grade, className }) => {
  useSyncExternalStore(subscribeOppGradeStyles, isOppGradeStylesLoaded, () => true);

  const text = (grade ?? '').trim();
  if (!text) return <span className="ipc-grade ipc-grade--empty">—</span>;

  const style = getOppGradeStyleLabel(text).toLowerCase();
  return (
    <span
      className={['ipc-grade', `ipc-grade--${style}`, className].filter(Boolean).join(' ')}
    >
      {text}
    </span>
  );
};
